import { useState, useEffect } from 'react'
import { CButton, CCard, CCardBody, CCardTitle, CCardText, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CFormInput, CTableDataCell, CRow, CCol, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CSpinner } from '@coreui/react'

import MedicationDetails from './MedicationDetails'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import MedicineCRUD from '../../services/general/Medication.api'
import Mastercarder from '../../components/shared/Mastercarder'
import Pageloader from '../../components/shared/Pageloader'
import { SaveActivity } from './save-activity'

const Medication = () => {
  const [filteredMedicationData, setFilteredMedicationData] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  const [allDiagnoses, setAllDiagnoses] = useState([])
  const [medicationData, setMedicationData] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [currentMedicationId, setCurrentMedicationId] = useState(-1)
  const [selectedDiagnoses, setSelectedDiagnoses] = useState([])
  const [selectedMedicationData, setSelectedMedicationData] = useState(null)
  const [boxView, setBoxView] = useState('box')
  const [isLoading, setIsLoading] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [selectMedicationOptions, setSelectMedicationOptions] = useState([])
  const [classData, setClassData] = useState([])
  const deleteMedication = async (idx) => {
    const medicationToDelete = medicationData.find((item) => item.ID === idx)

    if (!medicationToDelete) {
      return
    }

    const { Data } = medicationToDelete
    const { drugIntervention } = Data

    await MedicineCRUD('DELETE', idx, '')

    if (drugIntervention.length > 0) {
      const medicationsWithInterventions = medicationData.filter((medication) => medication.Data.drugIntervention && medication.Data.drugIntervention.some((item) => item.medicationName === Data.name))

      medicationsWithInterventions.forEach((medication) => {
        medication.Data.drugIntervention = medication.Data.drugIntervention.filter((item) => item.medicationName !== Data.name)
      })

      for (const med of medicationsWithInterventions) {
        await MedicineCRUD('UPDATE', med.ID.toString(), JSON.stringify(med.Data))
      }
    }

    await MedicineCRUD('DELETE', idx.toString())

    getData()
    setDeleteVisibleId(null)
    SaveActivity('Deleted Medication')
  }

  const handleDiagnosis = (diagnosis) => {
    let diagnosisList = diagnosis !== '' ? diagnosis.split(',') : []
    if (diagnosisList.length > 0) {
      let temp = []
      for (let i = 0; i < diagnosisList.length; i++) {
        let t = allDiagnoses.find((obj) => obj.label.trim() === diagnosisList[i])
        temp.push(t)
      }
      return temp
    } else {
      return []
    }
  }

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase()

    setSearchTerm(term)

    const filteredData = medicationData.filter((item) => item.Data.name.toLowerCase().includes(term)).sort((a, b) => a.Data.name.localeCompare(b.Data.name)) // Alphabetic sorting
    setFilteredMedicationData(filteredData)
  }

  const fetchDiagnoses = async () => {
    try {
      const response = await GetDiagnosisData()
      const data = JSON.parse(response.d)
      const allDiagnoses = data.Data.map((diagnosis) => ({ value: diagnosis.id, label: diagnosis.Name }))
      setAllDiagnoses(allDiagnoses)
    } catch (error) {
      console.error('Error fetching diagnoses:', error)
    }
  }

  const handleEditMedication = (medication) => {
    const { ID, Data } = medication
    setCurrentMedicationId(ID)
    let diagnosis = handleDiagnosis(Data.diagnoses)
    setSelectedDiagnoses(diagnosis)
    setIsEditing(true)
    setSelectedMedicationData(Data)
    setModalVisible(true)
  }

  const handleOnClick = () => {
    setIsEditing(false)
    setCurrentMedicationId(null)
    setSelectedDiagnoses([])
    setModalVisible(true)
  }

  const getData = async () => {
    setIsPageLoading(true)
    let allMedicines = await MedicineCRUD('GET')
    let formattedData
    formattedData = JSON.parse(allMedicines.d)?.Data
    formattedData = formattedData.map((item) => {
      return {
        ...item,
        Data: JSON.parse(item.Data),
      }
    })
    if (formattedData) {
      setMedicationData(formattedData)
      setFilteredMedicationData(formattedData.sort((a, b) => a.Data.name.localeCompare(b.Data.name)))
    }
    setIsPageLoading(false)
  }

  useEffect(() => {
    getData()
    // const medicationData = JSON.parse(localStorage.getItem('medicationData'));
    // if (medicationData) {
    //     setMedicationData(medicationData);
    // } else {
    //     localStorage.setItem('medicationData', JSON.stringify([]));
    // }
  }, [])

  const saveMedication = async (newMedicationData) => {
    setIsLoading(true)
    try {
      const selectedID = isEditing ? currentMedicationId : -1

      const newMedication = {
        id: isEditing ? currentMedicationId : Date.now(),
        name: newMedicationData.medicationName,
        dosage: newMedicationData.dosage,
        class: newMedicationData.medicationClass,
        mechanismOfAction: newMedicationData.mechanismOfAction,
        sideEffect: newMedicationData.sideEffect,
        method: newMedicationData.method,
        specialtyMedication: Boolean(newMedicationData.specialtyMedication),
        diagnoses: newMedicationData.newDiagnosis,
        otherRoute: newMedicationData.otherRoute,
        drugIntervention: newMedicationData.drugIntervention,
        otherName: newMedicationData.otherName,
        standingTemplateName: newMedicationData.standingTemplateName,
        maxDose: newMedicationData.maxDose,
        therapeutic: newMedicationData.therapeutic,
        alerts: newMedicationData.alerts,
        therapeuticLevels: newMedicationData.therapeuticLevels,
        reason: newMedicationData.reason,
        diagnosisList: newMedicationData.diagnosisList,
        media: newMedicationData.media,
       MedicationReason: JSON.parse(newMedicationData.MedicationReason || '[]'),
      MedicationCode: JSON.parse(newMedicationData.MedicationCode || '[]'),
      }
      console.log('newMedicationData', newMedicationData)
      const { drugIntervention } = newMedicationData

      const updatedMedicationData = medicationData.map((med) => {
        const updatedDrugIntervention = drugIntervention
          .filter((di) => di.medicationName === med.Data.name)
          .map((di) => ({
            ...di,
            medicationName: newMedication.name,
            note: di.note,
          }))
          .filter((newDi) => !med.Data.drugIntervention?.some((existingDi) => existingDi.medicationName === newDi.medicationName && existingDi.note === newDi.note))

        if (updatedDrugIntervention.length > 0) {
          return {
            ...med,
            Data: {
              ...med.Data,
              // drugIntervention: updatedDrugIntervention
              drugIntervention: [...(med.drugIntervention || []), ...updatedDrugIntervention],
            },
          }
        }
        return med
      })

      if (updatedMedicationData.length > 0) {
        updatedMedicationData.forEach((item, idx) => {
          MedicineCRUD('UPDATE', item.ID.toString(), JSON.stringify(item.Data))
        })
      }

      let test = await MedicineCRUD(isEditing ? 'UPDATE' : 'INSERT', selectedID.toString(), JSON.stringify(newMedication))

      setIsEditing(false)
      getData()
      // setMedicationData(finalMedications);
      // localStorage.setItem('medicationData', JSON.stringify(finalMedications));
      setModalVisible(false)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    let result = medicationData.map((item) => {
      return {
        label: item.Data.name,
        value: item.Data.id,
      }
    })
    let classResult = medicationData
      .map((item) => {
        return {
          label: item.Data.class,
          value: item.Data.id,
        }
      })
      .filter((item) => item.label !== '')
    setSelectMedicationOptions(result)
    setClassData(classResult)
  }, [medicationData])

  useEffect(() => {
    fetchDiagnoses()
  }, [])

  return (
    <>
      <div className="position-relative medication-theme">
        <CCard className="m-2 master-grid-theme__toolbar medication-theme__toolbar">
          <CCardBody className="master-grid-theme__toolbar-body medication-theme__toolbar-body">
            <div className="d-flex align-items-center justify-content-start gap-2">
              {/* Search bar first */}
              <CFormInput type="text" placeholder="Search by Name" value={searchTerm} onChange={handleSearch} className="w-25 medication-theme__search" />
              {/* Add Medication button */}
              <CButton color="primary" onClick={handleOnClick} className="ui-action-btn ui-action-btn--primary">
                + Add Medication
              </CButton>
              {/* List and Details buttons */}
              {/* <span className="d-flex align-items-center  gap-1">
                                <CButton
                                    onClick={() => { setBoxView("box") }}
                                    style={{ background: boxView === 'box' ? "rgba(152, 142, 235, 0.18)" : "#fff" }}
                                    color={boxView === 'box' ? 'primary' : 'light'}
                                    variant="outline"
                                    className="text-black"
                                >
                                    List
                                </CButton>
                                <CButton
                                    onClick={() => { setBoxView("list") }}
                                    style={{ background: boxView === 'list' ? "rgba(152, 142, 235, 0.18)" : "#fff" }}
                                    color={boxView === 'list' ? 'primary' : 'light'}
                                    variant="outline"
                                    className="text-black"
                                >
                                    Detail
                                </CButton>
                            </span> */}
            </div>
          </CCardBody>
        </CCard>
        {boxView === 'box' ? (
          <CRow className="p-2 master-grid-theme__box-list medication-theme__box-list">
            {filteredMedicationData.map((item, index) => {
              return (
                <CCol xs={4} key={index}>
                  <Mastercarder deleteFunc={() => setDeleteVisibleId(item.ID)} editFunc={() => handleEditMedication(item)} heading={item.Data.name} subheading={`Other Name: ${item.Data.otherName}`}>
                    <CCardBody className="p-0">
                      {/* <div className="mt-2 d-flex align-items-center gap-4">
                                                    {item.Data.dosage && (
                                                        <div>
                                                            <p className="m-0 fw-bold text-black-50 p-0">Dosage</p>
                                                            <p className="m-0 fw-medium text-opacity-25 p-0">{Array.isArray(item.Data.dosage) ? item.Data.dosage.map((item) => (`${item}   `)) : item.Data.dosage}</p>
                                                        </div>
                                                    )}
                                                    {item.Data.method && (

                                                        <div>
                                                            <p className="m-0 fw-bold text-black-50 p-0">Route</p>
                                                            <p className="m-0 fw-medium text-opacity-25 p-0">{item.Data.method}</p>
                                                        </div>
                                                    )}
                                                </div> */}
                      {/* <div className="mt-2 p-2 rounded text-white" style={{ background: "rgb(152 142 235 / 18%)" }}>
                                                    <p className="m-0 text-warning fw-medium p-0">Side effect</p>
                                                    <p className="m-0 text-warning fw-medium p-0">{item.Data.sideEffect ? item.Data.sideEffect : ""}</p>
                                                </div> */}
                    </CCardBody>
                  </Mastercarder>
                </CCol>
              )
            })}
          </CRow>
        ) : (
          <div className="p-2 medication-theme__detail-list">
            {filteredMedicationData.map((item, index) => {
              return (
                <CCard key={index} className="mb-3 medication-theme__detail-card">
                  <CCardBody>
                    <CCardTitle className="mb-2">Medicine Name: {item.Data.name}</CCardTitle>
                    <CCardText>Other Name: {item.Data.otherName}</CCardText>
                    <CCardText>Dosage Value: {item.Data.dosage}</CCardText>
                    <CCardText>Standing Template Name: {item.Data.standingTemplateName}</CCardText>
                    <CCardText>Class: {item.Data.class}</CCardText>
                    <CCardText>
                      Method: {item.Data.method} {item.Data.otherRoute}
                    </CCardText>
                    <CCardText>Side Effect: {item.Data.sideEffect}</CCardText>
                    <CCardText>Max Dose: {item.Data.maxDose}</CCardText>
                    <CCardText>Therapeutic: {item.Data.therapeutic}</CCardText>
                    <div className="d-flex align-items-center gap-4">
                      <span>
                        <p className="p-0 m-0">Therapeutic Minimum Level</p>
                        <p className="py-1 px-0 m-0">{item.Data.therapeuticLevels?.min}</p>
                      </span>
                      <span>
                        <p className="p-0 m-0">Therapeutic Maximum Level</p>
                        <p className="py-1 px-0 m-0">{item.Data.therapeuticLevels?.max}</p>
                      </span>
                    </div>
                    <CCardText>
                      Diagnosis:{' '}
                      {item.Data.diagnoses?.split(',').map((diagnosis, i) => (
                        <span key={i} className="badge bg-warning text-white m-1 medication-theme__diagnosis-badge">
                          {diagnosis}
                        </span>
                      ))}
                    </CCardText>
                    {item.Data.drugIntervention && item.Data.drugIntervention.length > 0 && (
                      <CTable className="medication-theme__table">
                        <CTableHead>
                          <CTableRow>
                            <CTableHeaderCell>#</CTableHeaderCell>
                            <CTableHeaderCell>Medication Name</CTableHeaderCell>
                            <CTableHeaderCell>Note</CTableHeaderCell>
                          </CTableRow>
                        </CTableHead>
                        <CTableBody>
                          {item.Data.drugIntervention.map((drug, i) => (
                            <CTableRow key={i}>
                              <CTableDataCell>{i + 1}</CTableDataCell>
                              <CTableDataCell>{drug.medicationName}</CTableDataCell>
                              <CTableDataCell>{drug.note}</CTableDataCell>
                            </CTableRow>
                          ))}
                        </CTableBody>
                      </CTable>
                    )}
                    <CButton className="m-2" variant="outline" color="primary" onClick={() => handleEditMedication(item)}>
                      Edit
                    </CButton>
                    <CButton className="m-2" color="danger" variant="outline" onClick={() => setDeleteVisibleId(item.ID)}>
                      Delete
                    </CButton>
                  </CCardBody>
                </CCard>
              )
            })}
          </div>
        )}

        {medicationData.length < 0 && (
          <section style={{ height: '35rem' }} className="mx-2 d-flex justify-content-center align-items-center medication-theme__empty-state">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <h3 className="h2 mb-2">No Data Available</h3>
                    <p className="mb-5">The information you are looking for is currently not available.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {modalVisible && (
          <MedicationDetails
            modalVisible={modalVisible}
            setIsEditing={setIsEditing}
            setModalVisible={setModalVisible}
            setMedicationData={setMedicationData}
            setSelectedMedicationData={setSelectedMedicationData}
            allDiagnoses={allDiagnoses}
            medicationData={medicationData}
            selectedMedicationData={selectedMedicationData}
            selectedDiagnoses={selectedDiagnoses}
            setSelectedDiagnoses={setSelectedDiagnoses}
            saveMedicationfN={saveMedication}
            selectMedicationOptions={selectMedicationOptions}
            classData={classData}
            ButtonName={
              isLoading ? (
                <CSpinner component="span" size="sm" aria-label="Saving" />
              ) : isEditing ? (
                'Update Medication'
              ) : (
                'Save Medication'
              )
            }
          />
        )}

        <CModal className="patient-theme-modal medication-theme__delete-modal" visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              variant="outline"
              color="secondary"
            >
              Close
            </CButton>
            <CButton
              onClick={() => {
                deleteMedication(deleteVisibleId)
              }}
              className="text-white"
              color="danger"
            >
              Delete
            </CButton>
          </CModalFooter>
        </CModal>

        <Pageloader isLoading={isPageLoading} />
      </div>
    </>
  )
}

export default Medication
